import React from 'react'
import './PokerAtmosphere.scss'

const SpadeIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <path
      fill='currentColor'
      d='M32 6C22 18 10 28 10 40c0 7 5 12 12 12 3.5 0 6.5-1.4 8.5-3.6V56h3v-7.6C35.5 50.6 38.5 52 42 52c7 0 12-5 12-12 0-12-12-22-22-34Z'
    />
  </svg>
)

const HeartIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <path
      fill='currentColor'
      d='M32 56 10 34C4 28 4 18 11 13c6-4.5 14-3 18 2.5L32 20l3-4.5C39 10 47 8.5 53 13c7 5 7 15 1 21L32 56Z'
    />
  </svg>
)

const DiamondIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <path fill='currentColor' d='M32 4 56 32 32 60 8 32 32 4Z' />
  </svg>
)

const ClubIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <circle fill='currentColor' cx='20' cy='28' r='11' />
    <circle fill='currentColor' cx='44' cy='28' r='11' />
    <circle fill='currentColor' cx='32' cy='16' r='11' />
    <path fill='currentColor' d='M29 34h6v18c0 3-1.5 5.5-4 5.5S27 55 27 52V34Z' />
  </svg>
)

const ChipIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <circle cx='32' cy='32' r='28' fill='none' stroke='currentColor' strokeWidth='4' />
    <circle cx='32' cy='32' r='16' fill='none' stroke='currentColor' strokeWidth='3.2' />
    <path
      d='M32 4v8M32 52v8M4 32h8M52 32h8M12 12l6 6M46 46l6 6M12 52l6-6M46 18l6-6'
      fill='none'
      stroke='currentColor'
      strokeWidth='3.2'
      strokeLinecap='round'
    />
  </svg>
)

const CardIcon = () => (
  <svg viewBox='0 0 48 64' aria-hidden='true'>
    <rect x='2' y='2' width='44' height='60' rx='6' fill='currentColor' />
    <path
      d='M24 18c-4 5-8 8-8 13 0 3 2 5 5 5 1.4 0 2.6-.6 3.4-1.5V38h1.2v-3.5c.8.9 2 1.5 3.4 1.5 3 0 5-2 5-5 0-5-4-8-8-13Z'
      fill='#1a0f2e'
      opacity='0.55'
    />
  </svg>
)

const DiceIcon = () => (
  <svg viewBox='0 0 64 64' aria-hidden='true'>
    <rect x='6' y='6' width='52' height='52' rx='10' fill='currentColor' />
    <circle cx='20' cy='20' r='4.5' fill='#1a0f2e' />
    <circle cx='44' cy='20' r='4.5' fill='#1a0f2e' />
    <circle cx='32' cy='32' r='4.5' fill='#1a0f2e' />
    <circle cx='20' cy='44' r='4.5' fill='#1a0f2e' />
    <circle cx='44' cy='44' r='4.5' fill='#1a0f2e' />
  </svg>
)

const ICONS = {
  spade: SpadeIcon,
  heart: HeartIcon,
  diamond: DiamondIcon,
  club: ClubIcon,
  chip: ChipIcon,
  card: CardIcon,
  dice: DiceIcon
}

const MOTIFS = [
  { type: 'spade', top: 8, left: 6, size: 52, opacity: 0.38, blur: 1.2, rotate: -10, delay: 0 },
  { type: 'chip', top: 14, left: 90, size: 48, opacity: 0.34, blur: 1.4, rotate: 14, delay: 1.2 },
  { type: 'card', top: 42, left: 4, size: 42, opacity: 0.32, blur: 1.3, rotate: -12, delay: 0.8 },
  { type: 'heart', top: 48, left: 94, size: 40, opacity: 0.3, blur: 1.8, rotate: -8, delay: 2.4 },
  { type: 'club', top: 78, left: 12, size: 46, opacity: 0.34, blur: 1.2, rotate: 8, delay: 1.6 },
  { type: 'diamond', top: 86, left: 82, size: 44, opacity: 0.32, blur: 1.5, rotate: 8, delay: 2 },
  { type: 'dice', top: 22, left: 72, size: 40, opacity: 0.3, blur: 1.5, rotate: 12, delay: 0.4 },
  { type: 'spade', top: 68, left: 64, size: 48, opacity: 0.3, blur: 1.2, rotate: -6, delay: 1.8 }
]

const PokerAtmosphere = () => (
  <div className='v2-poker-atmosphere' aria-hidden='true'>
    {MOTIFS.map((item, index) => {
      const Icon = ICONS[item.type]
      return (
        <span
          key={`${item.type}-${index}`}
          className={`v2-poker-motif v2-poker-motif--${item.type}`}
          style={{
            top: `${item.top}%`,
            left: `${item.left}%`,
            width: `${item.size}px`,
            height: item.type === 'card' ? `${Math.round(item.size * 1.35)}px` : `${item.size}px`,
            '--motif-opacity': item.opacity,
            '--motif-blur': `${item.blur}px`,
            '--motif-rotate': `${item.rotate}deg`,
            '--motif-delay': `${item.delay}s`
          }}
        >
          <Icon />
        </span>
      )
    })}
  </div>
)

export default PokerAtmosphere
